module.exports = __webpack_public_path__ + "img/btn_2D_ov.a08a0182.png";